import {request, serviceUrl} from "@/utils/request";

// 获取空间树形结构
export function getSpaceTreeData(code, levelType) {
  return request({
    url: serviceUrl.deviceService + '/third/system/space/info/tree',
    params: {code, levelType}
  })
}

export function getSpaceTreeDataSystemType(systemType) {
  return request({
    url: serviceUrl.deviceService + '/third/system/space/info/tree',
    params: {systemType}
  })
}


// 根据空间id删除空间
export function deleteById(spaceId) {
    return request({
      method: 'DELETE',
      url: serviceUrl.deviceService + '/third/system/space/info/delete',
      params: {spaceId}
    })
  }

  // 根据空间id获取空间信息
export function getSpaceInfoById(spaceId, systemType) {
    return request({
      params: {
        spaceId,
        systemType
      },
      url: serviceUrl.deviceService + '/third/system/space/info'
    })
  }

  // 保存空间
export function saveByLevel(params) {
    return request({
      method: 'post',
      url: serviceUrl.deviceService + '/third/system/space/info/save/by/level',
      data: params
    })
  }